// project imports
// action - state management
import * as actionTypes from "../../actions/actionTypes";
import { getUnitSymbolByUnit, itemType, unitType } from "../types";
import { years } from "store/utils/years";
import { SALES_AND_MARKETING_EXPENSES_REDUCER_KEY } from "..";
import {
  same_marketingExpensesMonths,
  same_mediaBuyingMonths,
  same_ombaaMonths,
  same_seoMonths,
} from "./staticYearsData";

// This is to filter based on company types
import { SaaSCoType, GeneralCoType } from "constants/companyTypes";

const prefix = "same_";

// other revenue keys
export const MARKETING_EXPENSES_KEY = prefix + "marketingExpenses";
export const SAME_MEDIA_BUYING_KEY = prefix + "mediaBuying";
export const ONLINE_MEDIA_BUYING_ANALYTICS_AGENCY_KEY = prefix + "ombaa";
export const SEO_KEY = prefix + "seo";

export const salesAndMarketingExpenseItems = [
  MARKETING_EXPENSES_KEY,
  SAME_MEDIA_BUYING_KEY,
  ONLINE_MEDIA_BUYING_ANALYTICS_AGENCY_KEY,
  SEO_KEY,
];

export const initialState = {
  [MARKETING_EXPENSES_KEY]: {
    title: "Marketing Expenses",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      let result = 0;
      for (let i = 1; i < salesAndMarketingExpenseItems.length; i++) {
        result += Number(
          getReducerFunc(SALES_AND_MARKETING_EXPENSES_REDUCER_KEY)[
            salesAndMarketingExpenseItems[i]
          ]["years"][yearKey]
        );
      }
      return result;
    },
    months: same_marketingExpensesMonths,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
  [SAME_MEDIA_BUYING_KEY]: {
    title: "Media Buying",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 0;
    },
    months: same_mediaBuyingMonths,
    years: {
      [years.YEAR_1_KEY]: 300000,
      [years.YEAR_2_KEY]: 300000,
      [years.YEAR_3_KEY]: 300000,
      [years.YEAR_4_KEY]: 300000,
      [years.YEAR_5_KEY]: 300000,
    },
  },
  [ONLINE_MEDIA_BUYING_ANALYTICS_AGENCY_KEY]: {
    title: "Online Media Buying and Analytics Agency",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 0;
    },
    months: same_ombaaMonths,
    years: {
      [years.YEAR_1_KEY]: 1000,
      [years.YEAR_2_KEY]: 1000,
      [years.YEAR_3_KEY]: 1000,
      [years.YEAR_4_KEY]: 1000,
      [years.YEAR_5_KEY]: 1000,
    },
  },
  [SEO_KEY]: {
    title: "SEO",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 0;
    },
    months: same_seoMonths,
    years: {
      [years.YEAR_1_KEY]: 250,
      [years.YEAR_2_KEY]: 250,
      [years.YEAR_3_KEY]: 250,
      [years.YEAR_4_KEY]: 250,
      [years.YEAR_5_KEY]: 250,
    },
  },
};

// ==============================|| SUBSCRIPTION ACQUISITION ASSUMPTIONS REDUCER ||============================== //

const salesAndMarketingExpensesReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_SALES_AND_MARKETING_EXPENSE_BY_YEAR:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          years: {
            ...state[action.key].years,
            [action.yearKey]: [action.amount],
          },
        },
      };
    case actionTypes.SET_SALES_AND_MARKETING_EXPENSE_BY_MONTH:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          months: {
            ...state[action.key].months,
            [action.yearKey]: [action.amount],
          },
        },
      };
    case actionTypes.REPLACE_SALES_AND_MARKETING_EXPENSE_YEARS:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          months: action?.payload,
        },
      };
    case actionTypes.RESET_SALES_AND_MARKETING_EXPENSE_REDUCER:
      return initialState;
    default:
      return state;
  }
};

export default salesAndMarketingExpensesReducer;
